export class RecaptchaRequestModel {
  RecaptchaToken: string;
}
